import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Country } from '@models/pais/paisDto.model';
import { GeorefService } from '@services/georef/georef.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, map, Observable, of, startWith } from 'rxjs';

@Component({
  selector: 'app-buscar-pais-georef',
  standalone: true,
  imports: [
    MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatButtonModule,
    MatIconModule, MatTooltipModule, ReactiveFormsModule, NgxSpinnerModule, CommonModule
  ],
  templateUrl: './buscar-pais-georef.component.html',
  styleUrl: './buscar-pais-georef.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuscarPaisGeorefComponent {


  form: FormGroup;
  formBuilder: FormBuilder = new FormBuilder;
  paises!: Country[];

  @Input() name?: any;
  @Input() provincia: any;
  @Output() paisSeleccionado = new EventEmitter<any>();

  paisControl = new FormControl();
  filteredCountries!: Observable<Country[]>;

  constructor(
    private georefService: GeorefService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
  ) {

    this.form = this.formBuilder.group({
      Pais: [''],
    })
  }
  ngOnInit(): void {
    this.getCountries();
  }

  ngOnChanges(changes: SimpleChanges): void {


  }


  private filterCountries(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.paises.filter(country =>
      country.name.common.toLowerCase().includes(filterValue)
    );
  }



  getCountries() {
    this.spinner.show('spListadoPaises')
    this.georefService.getCountriesObservable()
      .subscribe(
        data => {
          this.spinner.hide('spListadoPaises')
          this.paises = data

          this.filteredCountries = this.form.controls["Pais"].valueChanges.pipe(
            startWith(''),
            map(value => this.filterCountries(value || ''))
          );

          if (this.name) {
            const localidad = this.paises.find(l => l.name.common === this.name)
            this.form.controls["Pais"].setValue(this.name);
          }


        },
        error => {
          this.spinner.hide('spListadoPaises')
          this.snackBar.showError(error, "Error");
        })
  }

  setSelectedCountry(country: string) {
    this.form.get('Pais')!.setValue(country);
    // Llamamos a onCountryChange para actualizar el campo 'Telefono'
    this.onCountryChange(country);
  }

  onCountryChange(country: string) {
    const paisSeleccionado = this.paises.find(p => p.name.common === country);
    if (paisSeleccionado) {
      this.paisSeleccionado.emit(paisSeleccionado);
    }
  }



}
